import React from 'react'
import { Box } from 'rebass/styled-components'

const SwiperLoader = ({ color }) => {
    return (
        <Box className={`swiper-lazy-preloader swiper-lazy-preloader-${color || 'white'}`} />
    )
}

export default SwiperLoader
